// extracted by mini-css-extract-plugin
export default {"highlighted":"_0IzP8"};